<div class="language">
  <h5 class="language__title">
    <profile-i18n-language [model]="model.name"></profile-i18n-language>
  </h5>

  <p class="language__proficiency">
    <profile-i18n-proficiency [model]="model.proficiency"></profile-i18n-proficiency>
  </p>

  <profile-dots-indicator [proficiency]="model.proficiency" class="language__indicator"></profile-dots-indicator>
</div>
